module.exports = __webpack_public_path__ + "img/r10.2c724b68.jpg";